module.exports = __webpack_public_path__ + "img/loading.4f80aa7d.svg";